import React from 'react';
import './App.css';
import Header from './components/Header';
import ScrollNav from './components/ScrollNav';
import Gallery from './components/Gallery';
import MapPlan from './components/MapPlan';
import Pricing from './components/Pricing';
import Services from './components/Services';
import Ideas from './components/Ideas';

function App() {
  return (
    <div className="App">
      <Header />
      <ScrollNav />
      <main className="main-content">
        <Gallery />
        <MapPlan />
        <Pricing />
        <Services />
        <Ideas />
      </main>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} The Town - Create Together Project</p>
      </footer>
    </div>
  );
}

export default App;
